import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=53ab54d2"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=53ab54d2&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ab54d2')) {
      api.createRecord('53ab54d2', component.options)
    } else {
      api.reload('53ab54d2', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=53ab54d2", function () {
      api.rerender('53ab54d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Modal.vue"
export default component.exports